module.exports = __webpack_public_path__ + "static/img/download1-1.3b9a4400.png";